module.exports = __webpack_public_path__ + "static/media/img4.9bf37f2f.png";